import * as THREE from 'three';
import { kamera } from './index';

export default class AudioSpieler {
	private höhrer = new THREE.AudioListener();
	private lader = new THREE.AudioLoader();
	private musikStatus = document.querySelector('#musik-status')! as HTMLInputElement;
	// Soundeffekte
	private apfelEffekt = new THREE.Audio(this.höhrer);
	private gameOverEffekt = new THREE.Audio(this.höhrer);
	private portalEffekt = new THREE.Audio(this.höhrer);

	constructor() {
		kamera.add(this.höhrer);
		this.lader.load('./audio/apfel.wav', (buffer) => {
			this.apfelEffekt.setBuffer(buffer);
		});

		this.lader.load('./audio/gameover.wav', (buffer) => {
			this.gameOverEffekt.setBuffer(buffer);
		});

		this.lader.load('./audio/portal.wav', (buffer) => {
			this.portalEffekt.setBuffer(buffer);
		});
	}
	// Wieder Pfeilschriftweise für "this"
	spieleApfelEffekt = () => {
		if(this.musikStatus.checked) this.apfelEffekt.play();
	}

	spieleGameOverEffekt = () => {
		if(this.musikStatus.checked) this.gameOverEffekt.play();
	}

	spielePortalEffekt = () => {
		if(this.musikStatus.checked) this.portalEffekt.play();
	}
}